import { Link } from "react-router-dom";
import { Coins, Banknote, Store, ScanSearch, Mail } from "lucide-react";
import { CASH_FACTOR } from "@/lib/constants";

const STEPS = [
  ["1", "Porta i tuoi articoli", "Carte singole, prodotti sigillati, accessori: portali nel nostro negozio, senza appuntamento."],
  ["2", "Valutazione dello staff", "Il nostro staff controlla condizioni e valore di mercato e ti fa una proposta sul momento."],
  ["3", "Scegli come essere pagato", "Accetti la proposta e scegli tra credito negozio o contanti."],
];

export default function SellInfoPage() {
  const cash = Math.round(CASH_FACTOR * 100);
  return (
    <div className="mx-auto max-w-[1100px] px-4 py-8 sm:px-6 sm:py-12">
      <p className="font-display text-sm uppercase tracking-[0.2em] text-violet-500">Vendi a Card Source</p>
      <h1 className="mt-2 font-display text-3xl tracking-tight sm:text-5xl" data-testid="sell-title">Vendi le tue carte e i tuoi prodotti</h1>
      <p className="mt-3 max-w-2xl text-stone-600">Ogni articolo viene valutato di persona dal nostro staff in negozio, così ricevi una proposta giusta e immediata.</p>
      <div className="mt-8 grid gap-4 md:grid-cols-3" data-testid="sell-steps">
        {STEPS.map(([n, t, d]) => (
          <div key={n} className="flex gap-4 rounded-2xl border border-black/10 bg-white p-5">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-black bg-violet-500 font-display text-white">{n}</span>
            <div><p className="font-display">{t}</p><p className="text-sm text-stone-600">{d}</p></div>
          </div>
        ))}
      </div>
      <div className="mt-8 grid gap-4 sm:grid-cols-2" data-testid="sell-payouts">
        <div className="rounded-2xl border-2 border-black bg-white p-6 shadow-[5px_5px_0_#000]">
          <Coins className="h-8 w-8 text-amber-600" />
          <p className="mt-3 font-display text-xl">Credito negozio</p>
          <p className="font-display text-4xl text-violet-500" data-testid="sell-credit-pct">100%</p>
          <p className="mt-1 text-sm text-stone-600">Ricevi l'intero valore della nostra proposta come credito, accreditato sul tuo account e utilizzabile online e in negozio.</p>
        </div>
        <div className="rounded-2xl border-2 border-black bg-white p-6 shadow-[5px_5px_0_#000]">
          <Banknote className="h-8 w-8 text-amber-600" />
          <p className="mt-3 font-display text-xl">Contanti</p>
          <p className="font-display text-4xl text-violet-500" data-testid="sell-cash-pct">{cash}%</p>
          <p className="mt-1 text-sm text-stone-600">Ricevi subito il {cash}% del valore della proposta in contanti.</p>
        </div>
      </div>
      <div className="mt-8 flex flex-wrap items-center gap-4 rounded-2xl bg-[#F6E7CB] p-6">
        <Store className="h-7 w-7" /><ScanSearch className="h-7 w-7" />
        <p className="flex-1 text-sm text-stone-700">Per accreditare il credito sul tuo account, registrati sul sito e comunica allo staff l'email del tuo account. Per lotti numerosi scrivici prima a <a href="mailto:info@cardsource.eu" className="font-semibold underline">info@cardsource.eu</a>.</p>
        <Link to="/assistenza#contatti" className="sticker-btn inline-flex items-center gap-2 rounded-full bg-black px-5 py-2.5 text-sm text-white" data-testid="sell-contact"><Mail className="h-4 w-4" />Contattaci</Link>
      </div>
    </div>
  );
}
